<template>
	<div id="informationDetail">
		<mobileHeader :url="'informationPoster?id='+id"></mobileHeader>
		<div class="tabs-nav">
			<p v-for="(item,index) in tabsList" :class="{active:tabsSelected==index}" @click="tabsChange(index)">{{item.name}}</p>
		</div>
		<div class="detail-img"><img :src="detail.image" alt=""></div>
		<div class="tabs-con">
			<div :class="'tab-pane '+(tabsSelected==0?'active':'')" v-html="detail.basic_parameters"></div>
			<div :class="'tab-pane sales_case '+(tabsSelected==1?'active':'')">
				<div class="sales_case-list" v-if="!sales_caseDetailShow">
					<div class="box" v-for="(item,index) in detail.sales_case" @click="sales_caseDetailChange(item)">
						<p class="title">{{item.title}}</p>
						<div class="img"><img :src="item.image" alt=""></div>
					</div>
				</div>
				<div class="sales_case-detail" v-html="sales_caseDetail" v-else></div>
			</div>
			<div :class="'tab-pane '+(tabsSelected==2?'active':'')" v-html="detail.main_index"></div>
		</div>
		
	</div>
</template>

<script>
import wxapi from "@/assets/js/wxsdk.js";
export default {
  mounted() {
	  this.id=this.$route.query.id;
	  this.getdetail();
	  wxapi.wxRegister(this.wxRegCallback)
  },
  data() {
    return {
	  id:"",
	  tabsList:[
		{name:"基本信息"},
		{name:"销售案例"},
		{name:"主要指标"},
	  ],
	  tabsSelected:0,
	  detail:{},
	  sales_caseDetailShow:false,
	  sales_caseDetail:"",
	  
	  sort:"",
	  lists:[],
	  search:"",
	  page:1,
	  links:[],
    }
  },
  components: {
	  
  },
  methods: {
	  wxRegCallback(){
		  wxapi.ShareTimeline({});
		  wxapi.ShareAppMessage({});
	  },
	  tabsChange(index){
		  this.tabsSelected=index;
		  this.sales_caseDetailShow=false;
	  },
	  getdetail(txt){
		  var t=this;
		  this.fetchGet(`/api/v1/ent/products/`+t.id).then((res) => {
			if(res.code==200){
				this.detail=res.data;
			}
		  })
	  },
	  sales_caseDetailChange(item){
		  this.sales_caseDetailShow=true;
		  this.sales_caseDetail=item.content;
	  },
  },
}
</script>
<style scoped>
	#informationDetail .detail-img{background: #fff;text-align: center;}
	#informationDetail .detail-img img{max-width: 100%;}
	#informationDetail .tabs-nav{margin-top: 0.22rem;overflow: hidden;padding: 0 0.24rem;}
	#informationDetail .tabs-nav p{width: 2.25rem;height: 0.6rem;line-height: 0.6rem;background: #DADADA;font-size: 0.3rem;color: #FFFFFF;text-align: center;float: left;margin-right: 0.12rem;cursor: pointer;}
	#informationDetail .tabs-nav p:nth-last-of-type(1){margin-right: 0;}
	#informationDetail .tabs-nav .active{background: #0096D6;font-weight: 500;}
	#informationDetail .tabs-con{margin-top: 0.3rem;/* padding: 0.26rem; */}
	#informationDetail .tabs-con .tab-pane{display: none;font-size: 0.28rem;line-height: 0.46rem;}
	#informationDetail .tabs-con .tab-pane.active{display: block;}
	#informationDetail .tabs-con .tab-pane>>>img{max-width: 100%;height: auto;}
	#informationDetail .tabs-con .tab-pane>>>.table-box div{display: flex;}
	#informationDetail .tabs-con .tab-pane>>>.table-box div p:nth-of-type(1){width: 30%;margin-right: 5%;}
	#informationDetail .tabs-con .tab-pane>>>.table-box div p:nth-of-type(2){width: 65%;}
	#informationDetail .tabs-con .tab-pane>>> > *{max-width: 100%;}
	#informationDetail .tabs-con .sales_case-list{overflow: hidden;padding: 0 0.25rem;}
	#informationDetail .tabs-con .sales_case-list .box{width: 100%;border: 1px solid #000000;float: left;margin-bottom: 0.3rem;box-sizing: border-box;cursor: pointer;}
	#informationDetail .tabs-con .sales_case-list .box p{padding: 0 0.22rem;line-height: 0.9rem;font-size: 0.28rem;font-weight: bold;border-bottom: 1px solid #000;}
	#informationDetail .tabs-con .sales_case-list .box .img{width: 100%;height: 3.58rem;overflow: hidden;}
	#informationDetail .tabs-con .sales_case-list .box .img img{width: 100%;}
	
</style>